const EmptyState = ({ icon, title, description, className = '' }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-2xl border border-cream/60 bg-white px-6 py-12 text-center text-slate-500 ${className}`}
    >
      {icon ? <div className="mb-4 text-primary">{icon}</div> : null}
      {title ? <p className="text-sm font-semibold text-slate-600">{title}</p> : null}
      {description ? <p className="mt-2 text-sm text-slate-500">{description}</p> : null}
    </div>
  );
};

export default EmptyState;


